import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import { geoFromIP } from 'utils/bolt/geo';
// import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		let geo = await geoFromIP();
		this.setState({ userCountry: geo?.countryCode });
	}

	renderLinks(items, type) {
		const { userCountry } = this.state;

		const usingOneTrust = this.props.store?.appData?.options?.oneTrustCookieConsent?.scripts;
		const oneTrustCookieToggleID = Object.keys(items).find(key => items[key]?.url?.toLowerCase()?.includes('onetrust.toggleinfodisplay'));

		if (type !== 'link' || !usingOneTrust || !oneTrustCookieToggleID || userCountry !== 'us') {
			return super.renderLinks(items, type);
		}

		if (items[oneTrustCookieToggleID]?.copyUS) {
			const itemsDupe = { ...items };
			const oneTrustCookieToggleUS = { ...items[oneTrustCookieToggleID] };
			oneTrustCookieToggleUS.$copy = oneTrustCookieToggleUS.copyUS;
			itemsDupe[oneTrustCookieToggleID] = oneTrustCookieToggleUS;
			return super.renderLinks(itemsDupe, type);
		}

		return super.renderLinks(items, type);
	}
}